const NAME = "TOTEM_MANAGEMENT";

export default NAME;
